export default "assets/images/icons/download-48fca079.svg";